// @ts-ignore
import React from "react";
import Skeleton from "../Skeleton.tsx";

export default function EventsSkeleton() {
    return (
        <div className="mt-14">
            <div className="bg-[#FAFAFA] backdrop-blur-lg border border-gray-200 flex flex-row justify-between w-full p-6 my-2 rounded-lg shadow-sm">
                <div className="flex flex-1 flex-col justify-between">
                    <Skeleton className="h-[24px] w-4/5" />
                    <Skeleton className="h-[18px] w-3/5" />
                    <Skeleton className="h-[14px] w-1/3 " />
                </div>
                <Skeleton className="w-20 h-20" />
            </div>
            <div className="bg-[#FAFAFA] backdrop-blur-lg border border-gray-200  flex flex-row justify-between w-full p-6 my-2 rounded-lg shadow-sm">
                <div className="flex flex-1 flex-col justify-between">
                    <Skeleton className="h-[24px] w-4/5" />
                    <Skeleton className="h-[18px] w-3/5" />
                    <Skeleton className="h-[14px] w-1/3 " />
                </div>
                <Skeleton className="w-20 h-20" />
            </div>
            <div className="bg-[#FAFAFA] backdrop-blur-lg border border-gray-200  flex flex-row justify-between w-full p-6 my-2 rounded-lg shadow-sm">
                <div className="flex flex-1 flex-col justify-between">
                    <Skeleton className="h-[24px] w-4/5" />
                    <Skeleton className="h-[18px] w-3/5" />
                    <Skeleton className="h-[14px] w-1/3 " />
                </div>
                <Skeleton className="w-20 h-20" />
            </div>
        </div>
    );
}
